import $ from "jquery";

const init = () => {
  toggleButton();
};

const toggleButton = () => {
  $(".villa-read-more").click(function () {
    $(".villa-content").toggleClass("show");
    $(".villa-read-more .fas.fa-chevron-down").toggleClass("flip");

    if (!$(".villa-content").hasClass("show")) {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $(".villa-container").offset().top - 150,
        },
        2000
      );
    }

    if ($(".villa-content").hasClass("show")) {
      $(".villa-read-more .elementor-button-text").text("READ LESS");
    } else {
      $(".villa-read-more .elementor-button-text").text("READ MORE");
    }
  });
};

try {
  init();
} catch (error) {
  console.log(error);
}
